import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PeriodService } from '../../../../periods/period.service';
import { ReportResponseService } from '../../../services/report_response.service';
import Swal from 'sweetalert2';
import { UserService } from '../../../../user/services/user.service';
import { ReportDiscountsService } from '../../../../employee-discounts/services/report_discounts.service';
import { ConceptResponseService } from '../../../services/concept_response.service';
import { DistrictSurveyService } from '../../../../shared/services/district_survey.service';
@Component({
  selector: 'app-view-concepts',
  templateUrl: './view-concepts.component.html',
  styleUrl: './view-concepts.component.scss'
})
export class ViewConceptsComponent {
  isRContainersVisible = false; // Controla la visibilidad del contenedor izquierdo
  periods: any[] = []; // 🔹 Agregamos periodos
  selectedPeriod: any = ''; // 🔹 Nuevo campo para el periodo seleccionado
  selectedUserId: string = ''; // 🔹 Nuevo campo para el usuario seleccionado
  existingReport: boolean = false; // 🔹 Indica si existe un reporte en el periodo seleccionado
  selectedReportResponseId: string = ''; // 🔹 Nuevo campo para el reporte seleccionado
  reportResponseState: string = ''; // 🔹 Nuevo campo para el estado del reporte
  reportFindedById: boolean = false; // 🔹 Indica si se encontró un reporte por ID, de momento no se usa
  userRole: string = ''; // 🔹 Nuevo campo para el rol del usuario
  userCanEdit: boolean = false
  userCanSend: boolean = false // 🔹 Nuevo campo para indicar si el usuario puede enviar el reporte

  userCode?: string = ''; // 🔹 Nuevo campo para el código del usuario
  userName?: string = ''; // 🔹 Nuevo campo para el nombre del usuario

  currentState: any = {}
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private periodService: PeriodService, // 🔹 Agregar servicio para obtener los periodos
    private reportResponseService: ReportResponseService, // 🔹 Agregar servicio para obtener los reportes
    private reportDiscountsService: ReportDiscountsService,
    private conceptResponseService: ConceptResponseService,
    private userService: UserService,
    private districtSurveyService: DistrictSurveyService
  ) {

  }

  ngOnInit(): void {
    this.loadPeriods(); // 🔹 Cargar periodos

    //cargar el usuario
    this.selectedUserId = this.userService.getselectedUserId()

    //cargar el rol del usuario
    this.userService.userRole$.subscribe(role => {
      this.userRole = role;
    });

    //verificar si se está cargando el reporte por id
    this.reportResponseService.selectedReportResponseId$.subscribe((id: string) => {
      if (id) {
        this.configReport(id)
      } else {
        console.warn('No se recibió ningún ID en la ruta');
        //this.router.navigate(['/expense-reports/reports-review']); 
      }
    });
  }

  configReport(reportId: string) { //solo los admin pueden ver por id los reportes de otros usuarios
    if (this.userRole == 'Administrador') {
      this.reportResponseService.getById(reportId).subscribe((res: any) => {
        if (res) {
          this.selectedReportResponseId = reportId; // Establecer el ID del reporte seleccionado
          this.existingReport = true; // Si hay reporte, lo marcamos como existente
          this.selectedPeriod = res.period;
          this.reportResponseState = res.stateId;

          this.reportDiscountsService.setcurrentFilter({   //cargamos el filtro para el componente listDiscounts
            userId: res.userId,
            periodId: this.selectedPeriod._id,
            periodIsClosed: this.selectedPeriod.isClosed
          })

          if (res.stateId == '67bf30fae343839c29db3a3f' || res.stateId == '67bf37c8e343839c29db3a47') {
            this.userCanSend = true //el usuario puede enviar el reporte
          }

          if (res.userId != this.userService.getselectedUserId()) {

            //verificar ademas que el informe no se encuentre en estado enviado o aprobado, o pagado
            if (res.stateId == '6841ef4ff4f90fb64f363a15') {
              this.userCanEdit = false //si el reporte ya fue pagado, no se puede editar
              this.userService.setUserCanEdit(false)
            } else {
              this.userCanEdit = true
              this.userService.setUserCanEdit(true)
            }

          } else {
            this.userCanEdit = false //si el reporte es del mismo usuario, no puede editar
            this.userService.setUserCanEdit(false)
          }

          this.getUserInfo(res.userId); // Obtener información del usuario
        } else {
          Swal.fire('Error', 'Error al cargar la data de informe', 'error')
        }
      })
    } 
    
    /*else {
      Swal.fire('Error', 'No tienes permisos para ver este informe', 'error')
      this.router.navigate(['/expense-reports/reports-review']);
    } */
  }

  getUserInfo(userId: string) {
    // Obtener información del usuario
    this.userService.getById(userId).subscribe((user: any) => {
      if (user) {
        this.userCode = user.employee_code; // Asignar el código del usuario
        this.userName = user.name; // Asignar el nombre del usuario
      } else {
        console.warn('No se encontró información del usuario');
      }
    }, (error) => {
      console.error('Error al obtener la información del usuario:', error);
    });

  }


  toggleRContainers(): void {
    this.isRContainersVisible = !this.isRContainersVisible;
  }

  routingTo(route: string) {
    this.router.navigate(['expense-reports/' + route]);
  }
  loadPeriods() {
    this.periodService.get().subscribe((response: any) => {
      this.periods = [...response].sort((a, b) => (b.year - a.year) || (b.month - a.month));
    });
  }

  onIdDetected(id: string) {
    this.selectedReportResponseId = id;
  }

  //al cambiar periodo buscamos el reporte del usuario en ese periodo, si es que existe
  onPeriodChange() {
    this.selectedReportResponseId = ''; // Reiniciamos el ID del reporte seleccionado
    this.reportResponseState = ''; // Reiniciamos el estado del reporte
    this.existingReport = false; // Reiniciamos el estado de existencia del reporte
    Swal.fire({
      title: 'Buscando reporte para el periodo seleccionado...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });



    this.reportResponseService.get(this.selectedPeriod._id, this.selectedUserId).subscribe({
      next: (response: any) => {
        if (response) {
          if (response.length == 0) {
            Swal.fire('Info', 'No se encontró Informe para el periodo seleccionado, favor crear el informe o seleccionar otro periodo', 'info');
            this.existingReport = false; // Si no hay reporte, lo marcamos como inexistente
            Swal.close();
            return;
          }
          if (response.length > 1) {
            Swal.fire('Error', 'Hay mas de 1 informe para el periodo seleccionado, favor avisa al administrador del error ', 'error');
            this.existingReport = false
            Swal.close()
            return
          }
          this.selectedReportResponseId = response[0]._id;
          this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId);// Establecer el ID del reporte seleccionado
          this.reportResponseState = response[0].stateId;
          this.existingReport = true; // Si hay reporte, lo marcamos como existente

          if (this.userRole == 'Administrador') {
            this.userService.setUserCanEdit(true)
            this.userCanSend = true //el usuario puede enviar el reporte
          } else {
            if (this.userRole == 'Usuario') {
              if (this.reportResponseState == '67bf30fae343839c29db3a3f' || this.reportResponseState == '67bf37c8e343839c29db3a47') {
                this.userService.setUserCanEdit(true)
                this.userCanSend = true //el usuario puede enviar el reporte
              } else {
                this.userService.setUserCanEdit(false)
              }
            }
          }
          //cargamos la data para el componente listDiscounts
          this.reportDiscountsService.setcurrentFilter({
            userId: response[0].userId,
            periodId: this.selectedPeriod._id,
            periodIsClosed: this.selectedPeriod.isClosed
          })
          Swal.close();
          //this.periodService.setselectedPeriodId(this.selectedPeriod._id);
          this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId); // 🔹 Guardamos el ID del reporte seleccionado en el servicio
        } else {
          Swal.fire('Info', 'No se encontró Informe para el periodo seleccionado, favor crear el informe o seleccionar otro periodo', 'info');
          this.existingReport = false; // Si no hay reporte, lo marcamos como inexistente
          Swal.close();
          this.reportResponseService.setSelectedReportResponseId("");
        }
      },
      error: (err) => {
        Swal.fire('Error', 'Ocurrió un error al obtener los reportes', 'error');
        console.error('Error obteniendo reportes:', err);
        this.existingReport = false; // Si hay error, asumimos que no hay reporte
        Swal.close();
        this.reportResponseService.setSelectedReportResponseId("");

      }
    });
  }

  saveReportResponse() {
    Swal.fire({
      title: 'Creando Reporte...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    let userdata = {
      periodId: this.selectedPeriod._id,
      userId: this.selectedUserId
    }
    this.reportResponseService.save(userdata).subscribe({
      next: (response: any) => {
        this.selectedReportResponseId = response.ReportResponse._id;
        this.existingReport = true;
        setTimeout(() => {
          this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId);
          //this.periodService.setselectedPeriodId(this.selectedPeriod._id);
          this.userService.setUserCanEdit(true) //dejamos que el usuario pueda editar el reporte una vez creado
          this.userCanSend = true //el usuario puede enviar el reporte
          /* this.reportDiscountsService.setcurrentFilter({   //cargamos el filtro para el componente listDiscounts
            userId: this.selectedUserId,
            periodId: this.selectedPeriod._id,
            periodIsClosed: this.selectedPeriod.isClosed
          }) */
        }, 1000)
        Swal.close();
        Swal.fire('Éxito', 'Reporte creado', 'success');
      },
      error: (err) => {
        Swal.close();
        Swal.fire('Error', 'Ocurrió un error al crear el reporte', 'error');
        console.error('Error creando reporte:', err);
      }
    });
  }

  /* generatePdfReport() {
     Swal.fire({
       title: 'Cargando ZIP...',
       allowOutsideClick: false,
       didOpen: () => {
         Swal.showLoading();
       }
     });
     this.conceptResponseService.generatePdfReport(this.selectedReportResponseId).subscribe({
       next: (response: Blob) => {
         Swal.close(); // Cierra el modal de carga
         const blob = new Blob([response], { type: 'application/zip' });
         const url = window.URL.createObjectURL(blob);
         const a = document.createElement('a');
         a.href = url;
         a.download = 'reporte-informe.zip';
         a.click();
         window.URL.revokeObjectURL(url);
       },
       error: (error) => {
         Swal.close();
         console.error("Error al descargar el ZIP:", error);
       }
     });
   }*/

  generatePdfReport() {
    Swal.fire({
      title: 'Cargando Reporte...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.conceptResponseService.generatePdfReport(this.selectedReportResponseId).subscribe({
      next: ({ blob, fileName }) => {
        Swal.close();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        Swal.close();
        console.error("Error al descargar el ZIP:", error);
      }
    });
  }


  sendReportResponse() {
    if (this.userRole === 'Usuario') {
      Swal.fire({
        title: 'Verificando información eclesiástica...',
        html: 'Por favor espera',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.districtSurveyService.checkCompletion(this.selectedUserId, this.selectedPeriod._id).subscribe({
        next: (result: any) => {
          Swal.close();
          if (result.required && !result.complete) {
            const missingNames = result.missingChurches.map((c: any) => c.name).join(', ');
            Swal.fire({
              icon: 'warning',
              title: 'No es posible enviar informe',
              text: `Debes completar la encuesta distrital del periodo (pestaña "Datos Eclesiasticos") para las siguientes iglesias de tu distrito: ${missingNames}`,
              confirmButtonText: 'Aceptar'
            });
          } else {
            this.confirmAndSendReport();
          }
        },
        error: (err) => {
          Swal.close();
          console.error('Error al verificar la información eclesiástica:', err);
          Swal.fire('Error', 'No se pudo verificar la información eclesiástica.', 'error');
        }
      });
    } else {
      this.confirmAndSendReport();
    }
  }

  confirmAndSendReport() {
    Swal.fire({
      title: 'Estás a punto de enviar el reporte',
      text: '¿Estás seguro de que deseas enviar el reporte?',
      input: 'textarea',
      inputLabel: 'Agrega un comentario (opcional)',
      inputPlaceholder: 'Escribe tu comentario aquí...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aquí'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar Informe'
    }).then((result) => {
      if (result.isConfirmed) {
        const comentario = result.value || '';
        Swal.fire({
          title: 'Enviando reporte...',
          html: 'Por favor espera',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        this.reportResponseService.updateStateInReview(this.selectedReportResponseId, comentario).subscribe({
          next: (response: any) => {
            Swal.close();
            Swal.fire('Éxito', 'Reporte enviado', 'success');
            this.userCanSend = false //el usuario ya no puede enviar el reporte
            this.userService.setUserCanEdit(false) //dejamos que el usuario no pueda editar el reporte una vez enviado
            this.reportResponseService.setSelectedReportResponseId(this.selectedReportResponseId)
          },
          error: (err) => {
            Swal.close();
            Swal.fire('Error', 'Ocurrió un error al enviar el reporte', 'error');
            console.error('Error enviando reporte:', err);
          }
        });

      }
    });
  }

}
